import { UseMutationOptions, useMutation } from 'react-query';

import CheckmateApiClient from '../../../../services/apiClient';
import { HttpResponseError } from '../../../../interfaces/IHttpResponseError';
import { IPagedSortedSearchResponseModel } from '../../../../interfaces/PagedSortedSearch';
import { ICaseResolutionModel } from '../../../../interfaces/ICaseResolutionModel';
import { ICaseResolutionSearchModel } from '../../case-resolution-admin/useGetCaseResolutionQuery';

const _apiClient = new CheckmateApiClient();

export const useGetViewCaseResolution = (
    reactQueryOptions?: UseMutationOptions<
        IPagedSortedSearchResponseModel<ICaseResolutionModel, undefined> | undefined,
        unknown,
        ICaseResolutionSearchModel,
        unknown
    >
) => {
    return useMutation({
        mutationFn: async (searchModel: ICaseResolutionSearchModel) => {
            const response = await _apiClient.searchCaseResolutionCases(searchModel);

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                const error: HttpResponseError = new Error('Failed to search case groups');
                error.status = response.httpResponse.status;
                throw error;
            }

            return response.payload;
        },
        ...reactQueryOptions,
    });
};